<div class="success-content">
  <div class="success-images" aria-hidden="true">
    <div class="image-cluster">
      <div class="person-img person-img--large">
        <img src="/assets/images/success-person-1.jpeg" alt="" />
      </div>
      <div class="person-img person-img--sm person-img--left">
        <img src="/assets/images/success-person-2.jpeg" alt="" />
      </div>
      <div class="person-img person-img--sm person-img--right">
        <img src="/assets/images/success-person-3.jpeg" alt="" />
      </div>
    </div>
  </div>

  <div class="success-text">
    <h1 class="success-title">
      <mark>{{ 'global.success_title_1' | translate }}</mark>
      {{ 'global.success_title_2' | translate }}
    </h1>
    <p class="success-description">{{ 'global.success_description' | translate }}</p>
    <p class="success-cta">
      <strong>{{ 'global.success_cta' | translate }}</strong>
    </p>
    <button class="btn w-md h-lg secondary" (click)="submit()">{{ 'global.discover_more' | translate }}</button>
  </div>
</div>

<div class="wrapper">
  <div *ngFor="let i of getRange(149); let index = index" [class]="'confetti-' + index"></div>
</div>
